/* eslint-disable */
import React, { PropTypes } from 'react';
import RCG from 'react-captcha-generator';
import $ from 'jquery';
import './css/cadastrarProtocolo.css'
class Erro extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
        }
        this.setCaptchaValue = this.setCaptchaValue.bind(this);
        this.setCaptchaUserValue = this.setCaptchaUserValue.bind(this);
        this.refreshCaptcha = this.refreshCaptcha.bind(this);

    }

    setCaptchaValue(text){
        this.props.setCaptchaValue(text);
    }

    setCaptchaUserValue(e) {
        this.props.setCaptchaUserValue(e.target.value);
    }

    refreshCaptcha(){

        this.props.refreshCaptcha();
    }
    componentWillReceiveProps(nextProps) {
            if(nextProps.showError){
                $(this.refs.errCaptcha).show();
            }
            else{
                $(this.refs.errCaptcha).hide();
            }

    }

    render() {
        
         //console.log('this.props.showError ', this.props.showError)
        return (
            <div >
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                    <RCG result={this.setCaptchaValue} key={this.props.idx} />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-10 ">
                    <input type="text" className="form-control" placeholder="captcha" ref='txtCaptcha' name="txtCaptcha" id='txtCaptcha' onChange={this.setCaptchaUserValue} value={this.state.captchaUserValue} />
                    <span ref='errCaptcha' style={{ display:'none' }} className="has-error" >*Captcha inválido</span>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 linhaRefresh">
                    <a href='javascript:' className='linkRefresh' onClick={this.refreshCaptcha}><i className="fa fa-refresh" title='Atualizar'></i></a>
                </div>
            </div>

        );
    }
}
Erro.contextTypes = {
    router: React.PropTypes.object
};



export default Erro;



/** WEBPACK FOOTER **
 ** ./src/components/Captcha.js
 **/